import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { PartTypeSchema } from "../generated/prisma/zod";
import { ExtendedPartSchema } from "../types";

const c = initContract();

export const aiContract = c.router({
  updateLayoutNesting: {
    method: "PUT",
    path: "/ai/layout-nesting/:id",
    body: z.object({
      materialLayoutId: z.string(),
      cutWidth: z.number(),
      skeletonWidth: z.number(),
      quantity: z.number(),
      part: ExtendedPartSchema.pick({
        height: true,
        width: true,
        length: true,
        type: true,
        tubeThickness: true,
      }),
    }),
    responses: {
      200: z.object({
        maxNumberOfItemsPerPanel: z.number(),
        layoutNesting: z.object({
          isError: z.boolean(),
          error: z.string().optional(),
          panels: z.array(
            z.object({
              name: z.string(),
              width: z.number(),
              height: z.number(),
            }),
          ),
          items: z.array(
            z.object({
              name: z.string().optional(),
              width: z.number(),
              height: z.number(),
              x: z.number(),
              y: z.number(),
              type: z.union([z.literal("used"), z.literal("unused")]),
              rotate: z.boolean(),
              panel: z.string(),
            }),
          ),
          scrapRatio: z.number(),
          unusedArea: z.number().optional(),
          skeletonWidth: z.number(),
          cutWidth: z.number(),
          scrapRatioBillingRate: z.number().optional(),
          partType: PartTypeSchema.optional(),
        }),
      }),
    },
  },
});
